import { defineMessages } from 'react-intl';

export const carouseNavlMessages = defineMessages({
  ariaPrevButton: {
    id: 'recoCarousel.aria,prevButton',
    defaultMessage: 'Vorheriges Element',
  },
  ariaNextButton: {
    id: 'recoCarousel.aria.nextButton',
    defaultMessage: 'Nächstes Element',
  },
});
